module.exports = __webpack_public_path__ + "static/media/mail.4b77c038.png";